<script lang="ts">
  import { MARK, WORDMARK } from "#lib/ui/brand.generated.ts";

  let { compact }: { compact: boolean } = $props();

  const WORD_HEIGHT = 15;
  const MARK_SIZE = 18;
  const CELLS = MARK.rest
    .split("Z")
    .filter((cell) => cell !== "")
    .map((cell) => `${cell}Z`);
</script>

<span
  class={["brand", compact && "compact"]}
  style:--word="{WORD_HEIGHT * WORDMARK.ratio}px"
  style:--mark="{MARK_SIZE}px"
  style:--last={WORDMARK.letters.length - 1}
>
  <svg
    class="word"
    height={WORD_HEIGHT}
    width={WORD_HEIGHT * WORDMARK.ratio}
    viewBox={WORDMARK.viewBox}
    fill="currentColor"
    aria-hidden="true"
  >
    {#each WORDMARK.letters as letter, index (letter.x)}
      <path
        class="letter"
        style:--n={index}
        style:--dx="{letter.x}px"
        d={letter.d}
        transform="translate({letter.x} 0)"
      />
    {/each}
  </svg>
  <svg class="mark" width={MARK_SIZE} height={MARK_SIZE} viewBox={MARK.viewBox} aria-hidden="true">
    {#each CELLS as cell, index (cell)}
      <path class="cell" style:--n={index} d={cell} fill="currentColor" />
    {/each}
    <path class="cell lit" style:--n={CELLS.length} d={MARK.lit} />
  </svg>
</span>

<style>
  .brand {
    position: relative;
    display: block;
    width: var(--word);
    height: var(--mark);
    overflow: hidden;
    transition: width 480ms cubic-bezier(0.65, 0, 0.35, 1) 80ms;
  }

  .compact {
    width: var(--mark);
    transition-delay: 0ms;
  }

  .word,
  .mark {
    position: absolute;
    top: 50%;
    left: 0;
    translate: 0 -50%;
    overflow: visible;
  }

  .letter {
    transition:
      opacity 240ms ease-out,
      filter 240ms ease-out,
      translate 480ms cubic-bezier(0.65, 0, 0.35, 1);
    transition-delay: calc(120ms + var(--n) * 18ms);
  }

  .compact .letter {
    opacity: 0;
    filter: blur(2px);
    translate: calc(var(--dx) * -1) 0;
    transition-delay: calc((var(--last) - var(--n)) * 18ms);
  }

  .cell {
    opacity: 0;
    scale: 0.4;
    transform-box: fill-box;
    transform-origin: center;
    transition:
      opacity 140ms ease-out,
      scale 140ms ease-out;
  }

  .compact .cell {
    opacity: 1;
    scale: 1;
    transition:
      opacity 220ms ease-out,
      scale 380ms cubic-bezier(0.34, 1.56, 0.64, 1);
    transition-delay: calc(180ms + var(--n) * 35ms);
  }

  .lit {
    fill: var(--series-1);
  }

  @media (prefers-reduced-motion: reduce) {
    .brand,
    .letter,
    .cell,
    .compact .letter,
    .compact .cell {
      transition: none;
    }
  }
</style>
